export const CardID = 1;
export const RowID = 2;
export const ColumnID = 3;
export const LinkID = 4;
//# sourceMappingURL=constants.js.map